<template>
  <div class="flex flex-col items-center justify-center px-4">
    <slot name="icon">
      <DotLottieVue
        class="h-40 w-40 sm:h-56 sm:w-56"
        autoplay
        loop
        src="/animations/search.lottie"
      />
    </slot>

    <h3 class="h4 opacity-80">{{ title }}</h3>
    <p class="opacity-80 text-center max-w-sm mt-2 mb-6">
      {{ description }}
    </p>
    <AppButton
      v-if="buttonText"
      :disabled="loading"
      :loading="loading"
      @click="handleAction"
    >
      {{ buttonText }}
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import AppButton from "../shared/AppButton.vue";

defineProps<{
  loading?: boolean;
  title?: string;
  description?: string;
  buttonText?: string;
}>();

const emit = defineEmits(["buttonAction"]);
const handleAction = () => {
  emit("buttonAction");
};
</script>
